import React from 'react'
import { Helmet } from 'react-helmet-async'

export const Header = () => (
  <Helmet>
    <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
  </Helmet>
)
